import { createStore } from 'vuex'
import { version } from '@/../package.json'

import auth from './modules/auth.store.js'
import dataloader from './modules/data-loader/main.store.js'
import dataloaderAssay from './modules/data-loader/assay.store.js'
import dataloaderDropbox from './modules/data-loader/dropbox.store.js'
import dataloaderDatasets from './modules/data-loader/datasets.store.js'
import dataloaderCollections from './modules/data-loader/collections.store.js'
import meta from './modules/meta.store.js'
import orders from './modules/orders.store.js'
import settings from './modules/settings/index.js'
import { cacheServerVersion } from '@/utils/modelMeta.js'
import { linkifyInternalUuid } from '@/utils'

function getDefaultState() {
  return {
    appVersion: version,
    serverVersion: null,
    isServerDown: false,
    registeredModuleIds: [],
    unregisterModuleHooks: [],
    loading: false,
    globalNotification: null,
    /*
      TODO: at the moment this is hard-coded to show a
      "new app version please reload" alert. This should be made
      generic, similar to the notification
    */
    alert: false,
  }
}

const store = createStore({
  modules: {
    auth,
    dataloader: {
      namespaced: true,
      modules: {
        main: dataloader,
        assay: dataloaderAssay,
        dropbox: dataloaderDropbox,
        datasets: dataloaderDatasets,
        collections: dataloaderCollections,
      },
    },
    meta,
    orders,
    settings,
    // modules placeholders for list pages
    serverSettings: {
      namespaced: true,
    },
    sessionSettings: {
      namespaced: true,
    },
  },
  state: Object.assign(
    { notification: null },
    // avoids destroying notification on store reset
    getDefaultState(),
  ),
  actions: {
    reset({ dispatch, commit }) {
      const defaultState = getDefaultState()
      dispatch('settings/reset')
      dispatch('meta/reset')
      commit('reset', defaultState)
    },
  },
  mutations: {
    reset(state, defaultState) {
      /* Unregister all registered store modules */
      state.unregisterModuleHooks.forEach((f) => f())
      // It's VERY important to keep 'state' when resetting
      // and not starting from '{}' because one would lose
      // wverything that was added after creation,
      // incl. store modules...
      Object.assign(state, defaultState)
    },
    addUnregisterModuleHooks(state, boundUnregisterFunc) {
      state.unregisterModuleHooks.push(boundUnregisterFunc)
    },
    alert(state, payload) {
      state.alert = payload
    },
    loading(state, payload) {
      state.loading = payload
    },
    notify(state, payload) {
      let message = payload?.message || ''
      if (message) {
        message = linkifyInternalUuid(message)
        payload = { ...payload, message }
      }
      state.notification = payload

      if (payload && payload.type === 'success') {
        const duration = Number.isInteger(payload.duration)
          ? payload.duration
          : 3000
        setTimeout(() => {
          // make sure there wasn't an error in the meantime
          if (state.notification && state.notification.type === 'success') {
            state.notification = null
          }
        }, duration)
      } else if (payload && Number.isInteger(payload.duration)) {
        setTimeout(() => {
          state.notification = null
        }, payload.duration)
      }
    },
    globalNotify(state, payload) {
      state.globalNotification = payload
    },
    setServerVersion(state, currentServerVersion) {
      cacheServerVersion(currentServerVersion)
      state.serverVersion = currentServerVersion
    },
    setIsServerDown(state, payload) {
      state.isServerDown = payload
    },
  },
  getters: {
    isReady: (state, getters) => {
      return getters['auth/isLoggedIn'] && getters['meta/isMetaReady']
    },
  },
})

export default store
export const useStore = () => store
